// 2026 搬家保險理賠完整指南
export const insuranceClaimsArticles = {
  21: {
    id: 21,
    title: '2026 搬家東西壞掉怎麼賠？保險理賠完整指南與真實案例',
    excerpt: '搬家過程中物品損壞怎麼辦？本文詳細說明搬家保險理賠流程、賠償標準、申請步驟，並分享真實理賠案例，讓您了解如何保障自己的權益。',
    category: 'cost',
    tags: ['搬家保險', '理賠流程', '物品損壞', '賠償標準', '權益保護', '2026理賠'],
    readTime: '15分鐘',
    author: '建鈞精緻搬家編輯團隊',
    publishDate: '2026年1月15日',
    image:
      'https://public.readdy.ai/ai/img_res/9112604d35492a7acb2774cc052d0a28.jpg',
    content: {
      introduction: '搬家過程中，物品損壞是許多人最擔心的問題。本文將詳細說明搬家保險的種類、理賠流程、賠償標準，並分享真實案例，幫助您了解如何保障自己的權益。',
      sections: [
        {
          title: '一、搬家保險的種類',
          content: [
            '大多數正規搬家公司都會投保「搬家責任險」，這是基本的保障。保障範圍包括搬運過程中因搬家公司疏失造成的物品損壞，理賠標準依照物品折舊後的市價或修復費用，通常有一定的免賠額度（如 $500-1,000）。',
            '如果您有貴重物品，建議考慮額外保險。全額保障險按物品實際價值理賠，指定物品險針對特定貴重物品投保，也可以自行向保險公司投保第三方保險。'
          ]
        },
        {
          title: '二、理賠申請流程',
          content: [
            '步驟 1：現場確認與拍照（搬家當天）- 發現物品損壞時，請立即停止搬運，多角度拍攝損壞情況，記錄損壞時間、地點、情況，並當場告知師傅和客服。',
            '步驟 2：填寫理賠申請（1-3天內）- 準備損壞物品照片（搬家前後對比）、物品購買證明（發票、收據）、搬家合約或收據、理賠申請表（搬家公司提供）。',
            '步驟 3：損害評估（3-7天）- 搬家公司會派員現場勘查（如需要），評估損壞程度，計算賠償金額，提出理賠方案。',
            '步驟 4：協商與理賠（7-14天）- 確認賠償金額，簽署理賠協議，收到賠償款項。'
          ]
        },
        {
          title: '三、賠償標準說明',
          content: [
            '一般物品賠償標準：輕微損壞（可修復）賠償修復費用，嚴重損壞（無法修復）賠償折舊後市價，全損則賠償折舊後市價或購買價格。',
            '物品折舊通常按以下方式計算：家具類每年折舊 10-15%，家電類每年折舊 15-20%，電子產品每年折舊 20-25%。計算公式：賠償金額 = 購買價格 × (1 - 折舊率 × 使用年數)。',
            '特殊物品如古董、藝術品需事先申報價值，按申報價值理賠。鋼琴、樂器需專業評估後理賠。電腦資料通常不在理賠範圍內。'
          ]
        },
        {
          title: '四、真實理賠案例',
          content: [
            '案例 1：電視螢幕破裂 - 搬運過程中 55 吋電視螢幕不慎碰撞破裂。客戶當場發現並拍照，填寫理賠申請表，提供購買發票（購買價 $25,000，使用 2 年）。折舊計算：$25,000 × (1 - 20% × 2) = $15,000，實際賠償 $15,000，7 天內匯款到帳。',
            '案例 2：實木餐桌刮傷 - 實木餐桌搬運時表面出現刮痕。現場確認損壞程度，評估為可修復損壞，安排專業師傅修復。免費修復處理，修復後客戶驗收滿意，無需金錢賠償。',
            '案例 3：玻璃茶几破裂 - 玻璃茶几在搬運過程中破裂。立即通報並拍照，提供購買證明（購買價 $8,000，使用 1 年），評估為全損。折舊計算：$8,000 × (1 - 15% × 1) = $6,800，實際賠償 $6,800，5 天內完成理賠。'
          ]
        },
        {
          title: '五、如何預防物品損壞',
          content: [
            '搬家前準備：拍照記錄搬家前所有物品狀態，提前告知搬家公司需特別注意的物品，易碎品使用專業包裝材料，貴重物品建議加保。',
            '搬家當天：全程監督搬運過程，物品搬入後立即檢查，保留所有包裝材料直到確認無損。'
          ]
        },
        {
          title: '六、常見問題解答',
          content: [
            'Q1：搬家公司不願意理賠怎麼辦？A：保留所有證據（照片、合約、通訊記錄），向消費者保護協會申訴，必要時可透過法律途徑解決。',
            'Q2：貴重物品沒有購買證明怎麼辦？A：提供同類商品的市場價格參考，提供銀行刷卡記錄，搬家前拍照並記錄物品狀態。',
            'Q3：搬家後幾天內可以申請理賠？A：建議搬家當天立即檢查並申報，一般搬家公司接受 3-7 天內的理賠申請，超過時限可能影響理賠權益。',
            'Q4：哪些損壞不在理賠範圍內？A：物品本身的瑕疵或老化、客戶自行包裝不當造成的損壞、天災等不可抗力因素、未申報的貴重物品。'
          ]
        },
        {
          title: '七、建鈞搬家保障承諾',
          content: [
            '我們的保障：全程保險 - 所有搬家服務皆有責任險保障；快速理賠 - 7 天內完成理賠程序；專人服務 - 專人協助理賠申請；透明流程 - 理賠標準公開透明。',
            '聯絡我們：電話 0978-900-081、LINE @285yavdh、服務時間 24 小時。'
          ]
        }
      ],
      conclusion: '選擇有保障的搬家公司，是保護您財物安全的第一步。建鈞精緻搬家提供完整的保險保障，讓您搬家更安心。如有任何問題，歡迎隨時聯繫我們！'
    },
    relatedArticles: [105, 106, 107, 2, 3, 4]
  }
};
